import { render, staticRenderFns } from "./Forms1099CustomerView.vue?vue&type=template&id=981ce99c&scoped=true&"
import script from "./Forms1099CustomerView.vue?vue&type=script&lang=ts&"
export * from "./Forms1099CustomerView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981ce99c",
  null
  
)

export default component.exports